// Data service for CRM operations
import crmApi from '../utils/crmApi';

export const dataService = {
  // Client operations
  getClients: () => crmApi.get('/clients'),
  getClient: (id) => crmApi.get(`/clients/${id}`),
  createClient: (data) => crmApi.post('/clients', data),
  updateClient: (id, data) => crmApi.put(`/clients/${id}`, data),
  deleteClient: (id) => crmApi.delete(`/clients/${id}`),

  // Task operations
  getTasks: () => crmApi.get('/tasks'),
  getTask: (id) => crmApi.get(`/tasks/${id}`),
  createTask: (data) => crmApi.post('/tasks', data),
  updateTask: (id, data) => crmApi.put(`/tasks/${id}`, data),
  deleteTask: (id) => crmApi.delete(`/tasks/${id}`),

  // Analytics operations
  getAnalytics: () => crmApi.get('/analytics'),
  getDashboardData: () => crmApi.get('/analytics/dashboard'),

  // Agency operations
  getAgencies: () => crmApi.get('/agencies'),
  getAgency: (id) => crmApi.get(`/agencies/${id}`),
  createAgency: (data) => crmApi.post('/agencies', data),
  updateAgency: (id, data) => crmApi.put(`/agencies/${id}`, data),
  deleteAgency: (id) => crmApi.delete(`/agencies/${id}`),
};

export default dataService;
